export default "__VITE_ASSET__$h9jQF7___"